var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 356,
    height: 75,
    viewBox: "0 0 356 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4",
    "data-name": "Rect\\xE1ngulo 4",
    width: 356,
    height: 75,
    transform: "translate(0.5 0.596)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-keypago",
    transform: "translate(-0.5 -0.596)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M59.139,75.8H9.229A8.6,8.6,0,0,1,.5,67.3V9A8.6,8.6,0,0,1,9.229.5h49.91A8.6,8.6,0,0,1,67.868,9V67.344A8.624,8.624,0,0,1,59.139,75.8Z",
    fill: "#201646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M19.01,20.179,6.976,6.973c-.69-.768-1.726-.816-1.726.192V56.337c0,1.009,1.036,1.249,1.726.432L19.01,43.516a1.044,1.044,0,0,0,.3-.72V20.9A1.044,1.044,0,0,0,19.01,20.179Z",
    transform: "translate(4.916 6.108)",
    fill: "#dbf227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M15.813,5.337H42.346a1.089,1.089,0,0,1,.838,1.825L20.6,32.421a1.131,1.131,0,0,0,0,1.441L43.036,59.12a1.1,1.1,0,0,1-.838,1.825H15.862a1.1,1.1,0,0,1-1.134-1.1V6.442A1.061,1.061,0,0,1,15.813,5.337Z",
    transform: "translate(14.722 5.007)",
    fill: "#dbf227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M60.294,34.642,73.758,21.533a1.308,1.308,0,0,0-.986-2.305H65.225L52.008,31.281V1.941A1.433,1.433,0,0,0,50.529.5H44.512a1.5,1.5,0,0,0-1.48,1.441v53.3a1.465,1.465,0,0,0,1.48,1.441h6.017a1.406,1.406,0,0,0,1.48-1.441V41.989l1.677-1.633L65.62,55.771A2.414,2.414,0,0,0,67,56.683h6.855a1.37,1.37,0,0,0,1.134-2.257Z",
    transform: "translate(44.021)",
    fill: "#201646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M89.019,14.362A16.837,16.837,0,0,0,77.134,9.608a18.586,18.586,0,0,0-18.494,18.68,19.421,19.421,0,0,0,5.573,13.83,17.915,17.915,0,0,0,12.823,5.138A18.69,18.69,0,0,0,90.6,41.974a1.281,1.281,0,0,0,0-1.873l-4.389-4.034a1.665,1.665,0,0,0-1.973-.1,10.992,10.992,0,0,1-7.2,2.545A8.954,8.954,0,0,1,68.75,32.61H92.422a1.414,1.414,0,0,0,1.381-1.2,36.543,36.543,0,0,0,.247-3.89C94.1,20.461,91.633,16.763,89.019,14.362ZM68.7,24.3a8.4,8.4,0,0,1,8.187-5.954A8.261,8.261,0,0,1,84.778,24.3Z",
    transform: "translate(60.175 9.427)",
    fill: "#201646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M111.721,9.679h-6.806c-.69,0-1.085.432-1.48,1.441L94.559,31.528l-8.631-20.36c-.444-1.056-.937-1.489-1.628-1.489H77.494a1.4,1.4,0,0,0-1.332,1.969L89.331,42.717,80.01,64.134a1.267,1.267,0,0,0,1.233,1.873H87.7a2.008,2.008,0,0,0,1.923-1.441L113,11.648A1.334,1.334,0,0,0,111.721,9.679Z",
    transform: "translate(78.21 9.501)",
    fill: "#201646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M115.484,9.679c-3.4,0-7.446,1.777-10.307,3.842V11.264A1.383,1.383,0,0,0,103.8,9.823H97.73a1.355,1.355,0,0,0-1.381,1.441v53.4a1.331,1.331,0,0,0,1.381,1.345H103.8a1.331,1.331,0,0,0,1.382-1.345V43.629c2.861,2.161,6.608,3.841,10.061,3.841,10.7,0,18.394-8.163,18.394-18.92C133.632,17.747,125.94,9.679,115.484,9.679Zm-.395,28.908c-5.672,0-9.518-4.514-9.518-10.036s3.846-9.8,9.518-9.8c5.474,0,9.322,4.178,9.322,9.748C124.412,34.025,120.417,38.587,115.089,38.587Z",
    transform: "translate(99.204 9.501)",
    fill: "#8e6ec8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M152.416,9.728h-5.967a1.434,1.434,0,0,0-1.479,1.441v2.257c-2.762-2.017-6.461-3.794-9.963-3.794a18.775,18.775,0,0,0-18.494,18.824c0,10.756,7.646,18.824,18.348,18.824,3.6,0,7.348-1.777,10.11-3.793v2.257a1.464,1.464,0,0,0,1.479,1.441h5.967a1.406,1.406,0,0,0,1.479-1.441V11.121A1.368,1.368,0,0,0,152.416,9.728ZM135.352,38.156a9.8,9.8,0,0,1,0-19.592,9.481,9.481,0,0,1,9.371,9.8C144.672,33.69,140.777,38.156,135.352,38.156Z",
    transform: "translate(120.073 9.452)",
    fill: "#8e6ec8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M172.749,9.847h-6.018a1.435,1.435,0,0,0-1.479,1.441v2.257C162.393,11.383,158.4,9.7,155.094,9.7c-10.456,0-18.3,8.163-18.3,18.872,0,10.8,7.743,18.872,18.445,18.872,3.451,0,7.151-1.777,10.01-3.841v2.3c0,4.034-.985,6.819-2.515,8.4a9.506,9.506,0,0,1-6.756,2.833,9.655,9.655,0,0,1-7.595-3.6,1.458,1.458,0,0,0-2.169-.144l-4.438,4.418a1.374,1.374,0,0,0-.1,1.873,19.256,19.256,0,0,0,14.3,6.291A17.665,17.665,0,0,0,168.657,60.8c3.944-3.842,5.523-8.6,5.523-19.112v-30.4A1.394,1.394,0,0,0,172.749,9.847ZM155.489,38.611c-5.672,0-9.469-4.562-9.469-10.084s3.946-9.748,9.369-9.748a9.53,9.53,0,0,1,9.471,9.8C164.909,34.1,161.506,38.611,155.489,38.611Z",
    transform: "translate(141.068 9.525)",
    fill: "#8e6ec8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M175.891,9.608a18.536,18.536,0,0,0-18.543,18.824,18.5,18.5,0,1,0,36.988,0C194.287,17.868,186.249,9.608,175.891,9.608Zm-.049,28.812c-5.277,0-9.223-4.466-9.223-9.988s3.9-9.988,9.223-9.988c5.376,0,9.271,4.466,9.271,9.988C185.114,33.907,181.17,38.42,175.842,38.42Z",
    transform: "translate(162.339 9.427)",
    fill: "#8e6ec8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e7eb819d10e8c1cd54f27146e9b5616c.svg";
export { ForwardRef as ReactComponent };